import { getDefaultKeyBinding, KeyBindingUtil } from 'draft-js';
import { Efuncs } from './EditorFuncs.js';
import { CONSTS } from 'constants/index';

const hasCommandModifier = KeyBindingUtil.hasCommandModifier;

export const handleKey = (e, props) => {
  const plainText = props.editorMode === CONSTS.EDITOR_MODE_TYPE.PLAIN;
  const richText = props.editorMode !== CONSTS.EDITOR_MODE_TYPE.PLAIN;
  switch (e.keyCode) {
    case 66:
      // B
      if (plainText && hasCommandModifier(e)) {
        return 'handled';
      }
      return getDefaultKeyBinding(e);
    case 73:
      // I
      if (plainText && hasCommandModifier(e)) {
        return 'handled';
      }
      return getDefaultKeyBinding(e);
    case 74:
      // J
      if (plainText && hasCommandModifier(e)) {
        return 'handled';
      }
      return getDefaultKeyBinding(e);
    case 85:
      // U
      if (plainText && hasCommandModifier(e)) {
        return 'handled';
      }
      return getDefaultKeyBinding(e);
    case 32:
      // space
      if (
        richText &&
        (Efuncs.unstyledHyphen(props) || Efuncs.unstyledAsterisk(props))
      ) {
        e.preventDefault();
        props.clearBlockAndSetType('unordered-list-item');
        return 'handled';
      } else if (richText && Efuncs.unstyledListNumber(props)) {
        e.preventDefault();
        props.clearBlockAndSetType('ordered-list-item');
        return 'handled';
      }
      return getDefaultKeyBinding(e);
    case 8:
      // backspace
      if (richText && Efuncs.openingEmptyListItem(props)) {
        props.toggleList(e);
        return 'handled';
      }
      if (Efuncs.deletingAtomicBlock(props)) {
        const newState = Efuncs.deleteAtomicBlock(
          props,
          Efuncs.deletingAtomicBlock(props)
        );
        props.onEditorStateChange(newState);
        return 'handled';
      }
      return getDefaultKeyBinding(e);
    default:
      return getDefaultKeyBinding(e);
  }
};

export const Keys = {
  handleKey,
};
